<template>
    <section class="service-screen-container main-container"
             v-animateonscroll="{ enterClass: 'fade-in'}"
             @animationend="showAnimation">
        <main-text-block :is-active-mini-paragraph="$isMobile"
                         :config-block="{
                            theme: 'dark'
                         }"
                         :main-title="mainTitle"/>
      <div class="right-container" v-if="!$isMobile" :key="idActiveCard"
           v-animateonscroll="{ enterClass: 'fade-in'}"
           @animationend="showAnimation">
        <transition-group name="fade-translate-y">
          <card-service v-for="(item, index) in activeInfo"
                        :class="['animation-opacity', {'is-active-opacity' : isVisibleCard(index)}]"
                        :focus-param-id="idSubCard"
                        @changeId="value => idSubCard = value"
                        :key="index"
                        :item="item"/>
        </transition-group>
        <div :class="['bg-container', 'animation-opacity', {'is-active-opacity' : isVisibleCard(9)}]">
          <img :src="getUrl('service-new.svg')" alt="decoration">
        </div>
      </div>
      <div class="right-container" v-else>
        <slider-banner :cards-info="activeInfo"
                       :class="['cards-service-slider', {'is-active-slider': isActiveCardMobile}]"
                       :is-active-row="true"
                       :is-active-padding="false"
                       :key="idActiveCard"
                       :class-name="'card-service-wrapper'"
                       @changeId="value => idSubCard = value">
          <template v-slot:card="{ item }">
            <card-service :focus-param-id="idSubCard"
                          :item="item"/>
          </template>
        </slider-banner>
        <div :class="['bg-container', 'animation-opacity', {'is-active-opacity' : isVisibleCard(9)}]">
          <img :src="getUrl('service-new.svg')" alt="decoration">
        </div>
      </div>

    </section>
</template>

<script>
import MainTextBlock from "@/components/entities/blocks/MainTextBlock.vue";
import OrangeTitleArrow from "@/components/shared/title-arrow/OrangeTitleArrow.vue";
import CardService from "@/components/entities/cards/CardService.vue";
import SliderBanner from "@/components/entities/SliderBanner.vue";

export default {
  name: "ServiceScreen",
  components: {SliderBanner, CardService, OrangeTitleArrow, MainTextBlock},
  data() {
    return {
      isActiveCardMobile: false,
      visibleIndexItem: -1,
      visibleIndexItemCard: -1,
      idActiveCard: 0,
      idActiveCardStatic: 0,
      idSubCard: 0,
      mainTitle: 'Наши\nкомпетенции',
      title: ['Hulla risus leo', 'Lorem ipsum ', 'Sit id eu elementum', 'Pellentesque ', 'Lorem ipsum '],
      info: {
        title: 'Lorem ipsum',
        text: 'Sit id eu elementum a ac facilisis eu pellentesque nisl. Pellentesque sit sapien nulla risus leo quam.'
      },
      timer: null,
      timerHide: null
    }
  },
  computed: {
    lengthAnimation() {
      return this.title.length
    },
    activeInfo() {
      return [
        {
          id: 0,
          title: 'Проектирование',
          text: 'Разработка конструкторской документации зажимной оснастки, в том числе специальной, с применением систем нулевого базирования и модульного принципа. Используем современные CAD/CAM системы для обеспечения максимальной точности и технологичности изделий.'
        },
        {
          id: 1,
          title: 'Изготовление деталей и технологической оснастки',
          text: 'Изготовление деталей на современных станках с ЧПУ, с возможностью последующей передачи технологии заказчику. Всестороннее обеспечение контроля качества выпускаемой продукции.'
        },
        {
          id: 2,
          title: 'Расчетное тестирование специальной зажимной оснастки',
          text: 'Компьютерное моделирование и испытания оснастки на соответствие нагрузкам, точности позиционирования и скорости переналадки. Проверка на вибрации и деформации.'
        },
        {
          id: 3,
          title: 'Инжиниринг',
          text: 'Полный цикл внедрения: от разработки технологии обработки до написания управляющих программ и запуска деталей на оборудовании заказчика.'
        },
        {
          id: 4,
          title: 'Консалтинг',
          text: 'Оптимизация структуры производства внутри заводских служб на разных уровнях, помощь в организации новых производственных участков, стандартизация процессов и обучение персонала работе с современными зажимными системами.'
        },
        {
          id: 5,
          title: 'Оптимизация технологических процессов',
          text: 'Сокращение времени переналадки, повышение точности изготовления деталей и ресурса режущего инструмента, оснастки за счёт модернизации операций и внедрения автоматизированных решений.'
        },
        {
          id: 6,
          title: 'Технологический аудит производства',
          text: 'Комплексный анализ производства: оценка эффективности, выявление узких мест, проверка качества продукции и компетенций персонала.'
        },
        {
          id: 7,
          title: 'Сервисное обслуживание',
          text: 'Гарантийная и постгарантийная поддержка: ремонт, модернизация оснастки, консультации по эксплуатации и доработки под новые задачи.'
        }
      ]
    },
  },
  methods: {
    showAnimation() {
      this.visibleIndexItem = 0
      this.visibleIndexItemCard = 0;
      this.isActiveCardMobile = true;
      if(this.$isMobile) {
        this.idSubCard = 0
      }
      this.showNextItem();
      this.showNextItemCard();
    },
    showNextItemCard() {
      if (this.visibleIndexItemCard < this.activeInfo.length + 1) {
        this.timer = setTimeout(() => {
          this.visibleIndexItemCard += 1;
          this.showNextItemCard();
        }, 200)
      }
    },
    isVisibleCard(index) {
      return index <= this.visibleIndexItemCard
    }
  }
}
</script>

<style scoped lang="scss">
    .service-screen-container {
      flex-direction: column;
      .left-container {
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        .btn-container {
          display: flex;
          flex-direction: column;
        }
      }
    }
    .right-container {
      position: relative;
      display: flex;
      flex-direction: row;
      flex-wrap: wrap;

      .bg-container {
        pointer-events: none;
        filter: blur(10px);
        width: 100%;
        left: auto;
        bottom: auto;
        top: 50%;
        transform: translateY(-50%);
        right: auto;
        & img {
          object-fit: contain;
          width: 100%;
          height: 100%;
        }
      }
    }

    @media (max-width: 3024px){
      .service-screen-container {
        padding-top: 160px;
        padding-bottom: 160px;
        row-gap: 60px;
      }
      .right-container {
        column-gap: 10px;
        row-gap: 10px;
        .bg-container {
          height: 300px;
          padding: 0 84px;
        }
        & > * {
          height: 440px;
          flex-basis: calc(25% - 10px);
        }
      }
    }

    @media (max-width: 1920px) {
      .service-screen-container {
        padding-top: 120px;
        padding-bottom: 120px;
      }
      .right-container {
        column-gap: 10px;
        row-gap: 10px;
        .bg-container {
          filter: blur(6px);
          height: 241px;
          padding: 0 122px;
        }
        & > * {
          height: 390px;
          flex-basis: calc(25% - 10px);
        }
      }
    }
    @media (max-width: 1600px) {
      .service-screen-container {
        padding-top: 80px;
        padding-bottom: 80px;
        row-gap: 60px;
      }
      .right-container {
        column-gap: 10px;
        row-gap: 10px;
        .bg-container {
          filter: blur(3px);
          height: 171px;
          padding: 0 128px;
        }
        & > * {
          height: 320px;
          flex-basis: calc(25% - 10px);
        }
      }
    }
    @media (max-height: 800px) {
      .service-screen-container {
        padding-top: 60px;
        padding-bottom: 60px;
        row-gap: 40px;
      }
      .right-container {
        column-gap: 10px;
        row-gap: 10px;
        .bg-container {
          height: 171px;
          padding: 0 69px;
        }
        & > * {
          height: 290px;
          flex-basis: calc(25% - 10px);
        }
      }
    }

    @media (max-width: 1400px) and (min-height: 801px) {
      .service-screen-container {
        padding-top: 80px;
        padding-bottom: 80px;
        row-gap: 60px;
      }
      .right-container {
        column-gap: 10px;
        row-gap: 10px;
        .bg-container {
          height: 171px;
          padding: 0 128px;
        }
        & > * {
          height: 320px;
          flex-basis: calc(25% - 10px);
        }
      }
    }

    @media (max-width: 1133px) {
      .service-screen-container {
        padding-top: 60px;
        padding-bottom: 60px;
        row-gap: 40px;
      }
      .right-container {
        column-gap: 10px;
        row-gap: 10px;
        .bg-container {
          height: 171px;
          padding: 0 69px;
        }
        & > * {
          height: 290px;
          flex-basis: calc(25% - 10px);
        }
      }
    }
    @media (max-width: 769px) {
      .service-screen-container {
        padding-top: 60px;
        padding-bottom: 60px;
        row-gap: 40px;
      }
      .right-container {
        height: 290px;
        column-gap: 10px;
        row-gap: 10px;

        .cards-slider-container {
          ::v-deep(.card-service-wrapper) {
            min-height: 290px;
            max-height: 290px;
          }
        }
        .bg-container {
          height: 171px;
          padding: 0;
        }
      }
      //iPhone 14
    }

    @media (max-width: 769px)  and (min-height: 720px) and (max-height: 1000px) {
      //iPhone Plus
    }
    @media (min-height: 600px) and (max-height: 630px){
      //для экранов 8 плюс
    }

    @media (max-width: 375px){
      //iPhone 8
    }


    @media (max-width: 375px) and (min-height: 630px) {
      //iPhone X
    }


    @media (max-width: 320px) {
      //iPhone SE
    }

    @media (min-width: 3025px) {
      .service-screen-container {
        padding-top: 160px;
        padding-bottom: 160px;
        row-gap: 80px;
      }
      .right-container {
        column-gap: 10px;
        row-gap: 10px;
        .bg-container {
          height: 795px;
          padding: 0 64px;
        }
        & > * {
          height: 795px;
          flex-basis: calc(25% - 10px);
        }
      }
    }

</style>